<template>
  <div>
    <el-form-item label="采集资源">
      <el-select clearable v-model="data.resourceId" placeholder="请选择采集资源：" @change="resourceIdChange">
          <el-option
          v-for="item in resource"
          :key="item.resourceId"
          :label="item.tableComment"
          :value="item.resourceId">
          </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="搜索显隐">
      <el-switch v-model="data.searchShow"></el-switch>
    </el-form-item>
    <el-form-item label="序号显隐">
      <el-switch v-model="data.index"></el-switch>
    </el-form-item>
    <el-form-item label="刷新频率(秒)">
      <el-input v-model="data.rate" placeholder="主动刷新频率"></el-input>
    </el-form-item>
    <el-divider content-position="left">排序</el-divider>
    <DynamicOrder :orderData.sync="data.orderItemList" :column="data.children.column" />
    <el-form-item label="对齐方式">
      <el-select v-model="data.children.align"
                 placeholder="对齐方式">
        <el-option label="居左"
                   value="left"></el-option>
        <el-option label="居中"
                   value="center"></el-option>
        <el-option label="居右"
                   value="right"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="头部对齐方式" label-width="110px">
      <el-select v-model="data.children.headerAlign"
                 placeholder="对齐方式">
        <el-option label="居左"
                   value="left"></el-option>
        <el-option label="居中"
                   value="center"></el-option>
        <el-option label="居右"
                   value="right"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="字段宽度">
      <el-input-number v-model="data.children.labelWidth" :min="80" :max="300" :step="10" controls-position="right"></el-input-number>
    </el-form-item>
    <el-form-item label="是否禁用">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
    <el-form-item label="弹窗模式">
      <el-switch v-model="data.isTable"></el-switch>
    </el-form-item>
      <el-divider content-position="left">扩展操作按钮</el-divider>
      <el-form-item label="操作列宽度">
        <el-input-number v-model="data.menuWidth" />
        px
      </el-form-item>
      <ExtMenu :datas="data.extMenu" @on-data="handleSaveExtMenu" />
    <!-- </div> -->
    <template>
    <el-form-item label="列显隐" v-if="data.isTable">
      <el-switch v-model="data.columnBtn"></el-switch>
    </el-form-item>
    <el-form-item label="允许新增">
      <el-switch v-model="data.allowAdd"></el-switch>
    </el-form-item>
    <el-form-item label="允许编辑">
      <el-switch v-model="data.allowEdit"></el-switch>
    </el-form-item>
    <el-form-item label="允许删除">
      <el-switch v-model="data.allowDel"></el-switch>
    </el-form-item>
    <el-form-item label="删除回调名" v-if="data.isTable">
     <el-input v-model="data.beforeRowDeleteFunctionName" ></el-input>
    </el-form-item>
    <el-form-item label="新增回调名" v-if="data.isTable">
     <el-input v-model="data.beforeRowSaveFunctionName" ></el-input>
    </el-form-item>
    <el-form-item label="编辑回调名" v-if="data.isTable">
     <el-input v-model="data.beforeRowUpdateFunctionName" ></el-input>
    </el-form-item>
    <el-form-item label="打开弹窗回调名" v-if="data.isTable">
     <el-input v-model="data.beforeOpenFunctionName" ></el-input>
    </el-form-item>
    </template>
    <el-divider content-position="left">导入导出配置</el-divider>
    <el-form-item label="导入模板">
      <el-upload ref="upload" :action="`${API_CONFIG.API_BASE_URL}/common/document/upload`" :headers="getToken()"
      :on-remove="(file, fileList) => {handleFileRemove(file, fileList, 'Import')}"
      :http-request="(file) => {uploadFile(file,'Import')}"
      :on-success="(response, file, fileList) => {handleFileSuccess(response, file, fileList, 'Import')}"
      :on-error="handleFileRrror"
      :on-preview="handPreview"
        accept=".xls,.xlsx" :limit='1' :file-list="data.templatePathFileListImport" :auto-upload="true">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
      </el-upload>
    </el-form-item>
    <el-form-item label="导出模板">
      <el-upload ref="upload" :action="`${API_CONFIG.API_BASE_URL}/common/document/upload`" :headers="getToken()"
      :on-remove="(file, fileList) => {handleFileRemove(file, fileList, 'Export')}"
      :http-request="(file) => {uploadFile(file,'Export')}"
      :on-success="(response, file, fileList) => {handleFileSuccess(response, file, fileList, 'Export')}"
      :on-error="handleFileRrror"
      :on-preview="handPreview"
        accept=".xls,.xlsx" :limit='1' :file-list="data.templatePathFileListExport" :auto-upload="true">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
      </el-upload>
    </el-form-item>
  </div>
</template>

<script>
import DynamicOrder from '../DynamicOrder'
import { getToken } from '@/framework/util/auth'
import { API_CONFIG } from '@/page/config/base_config'
export default {
  name: 'ConfigDynamic',
  props: ['data'],
  components: {
    ExtMenu: () => import('./extMenu'),
    DynamicOrder
  },
  data() {
    return {
      API_CONFIG,
      getToken,
      resource: [],
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      }
    }
  },
  mounted() {
    this.getResource()
  },
  methods: {
    uploadFile(file, type) {
      let fd = new FormData()
      fd.append('file', file.file)
      this.$http.post('/common/document/upload', fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        this.$message.success('上传成功.')
        file.fileUniqueCode = res.data
        if (!this.data['templatePathFileList' + type]) this.data['templatePathFileList' + type] = []
        this.data['templatePathFileList' + type].push({
          name: file.file.name,
          fileUniqueCode: res.data
        })
      }).catch((error) => {
        this.$message.error(error.msg)
      })
    },
    /** 获得配置资源 */
    getResource() {
      this.$http.post('/data-collection-resourece/table-or-view-query', { entity: {}}, {
        params: {
          pageNum: 1,
          pageSize: 999
        }
      }).then(response => {
        this.resource = response.data.records.map(item => ({ tableComment: item.tableComment, resourceId: item.id }))
      }).catch(error => this.$message.error(error.msg || error.message))
    },
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    },
    handleSaveExtMenu(data) {
      this.data.extMenu = data
    },
    // 文件被移除的时候
    handleFileRemove(file, fileList, type) {
      this.data['templatePathFileList' + type] = []
      // .importTemplatePathFileList = []
    },
    // 文件上传成功
    handleFileSuccess(response, file, fileList, type) {
      file.fileUniqueCode = response.data
      if (!this.data['templatePathFileList' + type]) this.data['templatePathFileList' + type] = []
      this.data['templatePathFileList' + type].push({
        name: file.name,
        fileUniqueCode: response.data
      })
      this.$message.success('上传成功.')
    },
    // 文件上传失败
    handleFileRrror(err, file, fileList) {
      this.$message.error(err.msg || err.message)
    },
    handPreview(file) {
      if (file.fileUniqueCode && file.name) {
        this.$downloadFile.get('/common/document/download', {
          params: {
            fileName: file.name,
            fileUniqueCode: file.fileUniqueCode,
            doDownload: true
          }
        }).then(res => {}).catch(_ => {})
      } else {
        this.$message.error('文件已损坏')
      }
    }
  },
  watch: {
    'data.required': function(val) {
      if (val) this.validator.required = { required: true, message: `${this.data.label}必须填写` }
      else this.validator.required = null

      this.generateRule()
    },
    'data.isTable': function(val) {
      if (val) { this.data.component = 'dynamicForm' } else {
        this.data.component = 'dynamicForm2'
        delete this.data.allowAdd
        delete this.data.allowEdit
        delete this.data.allowDelete
      }
    }
  }
}
</script>
